module.exports = __webpack_public_path__ + "img/quill_demon_small.ee0b74c0.png";